document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-glamp-maintenance]').forEach((root) => {
    const choices = Array.from(root.querySelectorAll('[data-maintenance-choice]'));
    const variantInput = root.querySelector('[data-maintenance-variant]');
    const selectedName = root.querySelector('[data-maintenance-selected-name]');
    const selectedPrice = root.querySelector('[data-maintenance-selected-price]');
    const purchaseDate = root.querySelector('[data-maintenance-date]');

    if (purchaseDate) {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      purchaseDate.max = `${today.getFullYear()}-${month}-${day}`;
    }

    const updateSelection = (choice) => {
      if (!choice || !variantInput) return;
      variantInput.value = choice.value;
      if (selectedName) selectedName.textContent = choice.dataset.serviceName || '';
      if (selectedPrice) selectedPrice.textContent = choice.dataset.servicePrice || '';
    };

    choices.forEach((choice) => {
      choice.addEventListener('change', () => updateSelection(choice));
    });

    updateSelection(choices.find((choice) => choice.checked) || choices[0]);
  });
});
